import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";

const ViewModal = ({ 
  onClose, 
  isVisible, 
  onConfirm, // Function to handle different delete actions
  title = "Are you sure?", // Default title
  description = "Are you certain you want to delete this record?", // Default description
  data
}) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        onConfirm(); // Trigger the confirm action
      }
    };

    if (isVisible) {
      window.addEventListener("keydown", handleKeyDown);
    }

    // Cleanup the event listener on component unmount or when modal visibility changes
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isVisible, onConfirm]);

  

  return (
    <Modal
      show={isVisible}
      onHide={onClose}
      size={"md"}
      className="custom-modal"
      centered
    >
      <Modal.Header>
        <Modal.Title className="text-center">Description</Modal.Title>
      </Modal.Header>
      <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
        <div className="">
          <p className="mb-1">{data}</p>
          {/* <p className="text-slate-500 dark:text-zink-200">{description}</p> */}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ViewModal;